import { jsx } from "react/jsx-runtime";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { Box } from "braid-design-system";
import { gridRowGap, gridTemplateAreas, gridColumn, gridRowEnd, gridColumnPanel } from "./GridColumn.css.mjs";
const GridColumn = ({
  children,
  gridColumns,
  gridTemplateAreas: gridTemplateAreas$1,
  gridRowGap: gridRowGap$1,
  className
}) => {
  const endingGridLine = (gridTemplateAreas$1.split(" ").length + 1).toString();
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: [gridColumnPanel, className],
      style: assignInlineVars({
        [gridRowEnd]: endingGridLine,
        [gridColumn]: gridColumns,
        [gridTemplateAreas]: gridTemplateAreas$1,
        [gridRowGap]: gridRowGap$1
      }),
      children
    }
  );
};
export {
  GridColumn
};
